/** The program every new plot starts with: a small house that notices night and snow. */
export const STARTER_PLOT = `// A small house in the snow. Make it yours.
export function draw(g, t, env) {
  const night = env.light < 0.4
  g.cls(night ? 0 : 11)              // sky
  g.rectfill(0, 48, 64, 16, 7)       // snowy ground

  // the house
  g.rectfill(18, 30, 28, 20, 4)      // walls
  for (let i = 0; i < 10; i++)       // roof
    g.line(18 + i, 30 - i, 46 - i, 30 - i, 3)
  g.rectfill(38, 18, 4, 6, 5)        // chimney
  g.rectfill(29, 40, 6, 10, 1)       // door
  g.rectfill(22, 34, 5, 5, night ? 8 : 12)  // window lights up at night

  // a puff of smoke drifting up
  const puff = Math.floor(t * 2) % 4
  g.pset(40, 16 - puff, 6)

  // snow falls when the weather says so
  if (env.weather === 'snow') {
    const flakes = 10 + 40 * env.intensity
    for (let i = 0; i < flakes; i++) {
      const x = Math.floor(g.rnd(64))
      const y = Math.floor((t * 10 + i * 13) % 64)
      g.pset(x, y, 7)
    }
  }
}
`
